import { render } from "./QuickMain.vue?vue&type=template&id=0aa625b6"
import script from "./QuickMain.vue?vue&type=script&lang=js"
export * from "./QuickMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__